import {
  News,
  Articles,
  indvidualproducts,
  corporates,
  financials,
  SalaamDirectors,
  ManagementTeam,
  shariahData,
  advisorData,
  branches,
  annualperformance,
  MotorsTabs,
} from '../Data/Data';
import { tableData as faqTableData, shariahQuestion as faqShariahQuestion, productQuestion as faqProductQuestion } from '../Components/FAQs/FAQDescription';

// Strip HTML tags for searchable text
const stripHtml = (html) => {
  if (!html || typeof html !== 'string') return '';
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
};

// Keyword synonyms for better discovery (query word -> extra terms to match)
const SEARCH_SYNONYMS = {
  car: ['motor', 'vehicle', 'gari'],
  motor: ['car', 'vehicle'],
  bike: ['motorcycle', 'bike', 'salaamti'],
  health: ['sehat', 'medical', 'hospital'],
  islamic: ['takaful', 'shariah', 'halal'],
  insurance: ['takaful', 'coverage'],
  claim: ['claims', 'intimation'],
  contact: ['branch', 'address', 'phone', 'karachi', 'lahore', 'islamabad'],
  faq: ['question', 'answer', 'help'],
};

// All website routes/pages data
export const allRoutes = [
  { name: 'Home', path: '/', category: 'Home', description: 'Welcome to Salaam Takaful Limited' },
  { name: 'About Us', path: '/about-us', category: 'Company Information', description: 'Learn about Salaam Takaful Limited' },
  { name: 'Who We Are', path: '/whoweare', category: 'Company Information', description: 'Our mission, vision, and values' },
  { name: 'Company Details', path: '/company-details', category: 'Company Information', description: 'Corporate information and details' },
  { name: 'Governance', path: '/governance', category: 'Company Information', description: 'Corporate governance structure' },
  { name: 'Management', path: '/management', category: 'Company Information', description: 'Management team and leadership' },
  { name: 'Shariah Advisor', path: '/shariah', category: 'Company Information', description: 'Shariah compliance and advisory' },
  { name: 'ESG & Sustainability', path: '/esg', category: 'Company Information', description: 'Environmental, Social, and Governance initiatives' },
  { name: 'Life at Salaam', path: '/life-at-salaam', category: 'Company Information', description: 'Career opportunities and company culture' },
  { name: 'Individual Products', path: '/Individual-Product', category: 'Products', description: 'Individual insurance products' },
  // { name: 'Salam Motor', path: '/individualproduct/salammotor', category: 'Individual Products', description: 'Motor vehicle takaful coverage' },
  { name: 'Salam Home', path: '/individualproduct/salamhome', category: 'Individual Products', description: 'Home insurance takaful' },
  { name: 'Salam Personal', path: '/individualproduct/salampersonal', category: 'Individual Products', description: 'Personal accident takaful' },
  // { name: 'Salam Pet', path: '/individualproduct/salampet', category: 'Individual Products', description: 'Pet insurance takaful' },
  { name: 'Salam Sehat', path: '/individualproduct/salamsehat', category: 'Individual Products', description: 'Health insurance takaful' },
  { name: 'Salam Medical', path: '/individualproduct/salammedical', category: 'Individual Products', description: 'Medical insurance coverage' },
  { name: 'Salam Travel', path: '/individualproduct/salamtravel', category: 'Individual Products', description: 'Travel insurance takaful' },
  { name: 'Corporate Products', path: '/Corporate-Product', category: 'Products', description: 'Corporate insurance solutions' },
  { name: 'Salam Livestock', path: '/corporateproduct/salamlivestock', category: 'Corporate Products', description: 'Livestock insurance takaful' },
  // { name: 'Salam Crop', path: '/corporateproduct/salamcrop', category: 'Corporate Products', description: 'Crop insurance takaful' },
  { name: 'Salam Miscellaneous', path: '/corporateproduct/salam-miscellaneous', category: 'Corporate Products', description: 'Miscellaneous corporate coverage' },
  { name: 'Salam Engineering', path: '/corporateproduct/salam-engineering', category: 'Corporate Products', description: 'Engineering insurance takaful' },
  // { name: 'Salaam Group Health', path: '/corporateproduct/salaam-group-health', category: 'Corporate Products', description: 'Group health insurance' },
  { name: 'Salam Fire', path: '/corporateproduct/salam-fire', category: 'Corporate Products', description: 'Fire insurance coverage' },
  { name: 'Salam Marine', path: '/corporateproduct/salam-marine', category: 'Corporate Products', description: 'Marine insurance takaful' },
  { name: 'Financial Products', path: '/Financial-Product', category: 'Products', description: 'Financial institution products' },
  { name: 'Salaam Banker', path: '/financialproduct/salaam-banker', category: 'Financial Products', description: 'Banking insurance solutions' },
  { name: 'Salaam Professional', path: '/financialproduct/salaam-professional', category: 'Financial Products', description: 'Professional indemnity insurance' },
  { name: 'Salaam Computer', path: '/financialproduct/salaam-computer', category: 'Financial Products', description: 'Computer insurance coverage' },
  { name: 'Salaam Plastic Card', path: '/financialproduct/salaam-plasticcard', category: 'Financial Products', description: 'Plastic card insurance' },
  { name: 'Salaam Deposit', path: '/financialproduct/salaam-deposit', category: 'Financial Products', description: 'Deposit protection insurance' },
  { name: 'Salaam Cyber', path: '/financialproduct/salaam-cyber', category: 'Financial Products', description: 'Cyber security insurance' },
  { name: 'Buy Now', path: '/buynow', category: 'Services', description: 'Purchase insurance online' },
  { name: 'E-Verify', path: '/e-verify', category: 'Services', description: 'Verify your insurance certificate' },
  { name: 'Claim Intimation', path: '/claim', category: 'Services', description: 'File an insurance claim' },
  { name: 'FIO', path: '/fio', category: 'Services', description: 'Free look period information' },
  { name: 'News & Announcements', path: '/news-and-announcements', category: 'Media', description: 'Latest news and announcements' },
  { name: 'Articles & Blogs', path: '/articles-and-blogs', category: 'Media', description: 'Articles and blog posts' },
  { name: 'Annual Performance', path: '/annual-performance', category: 'Media', description: 'Annual performance reviews' },
  { name: 'Awards & Recognition', path: '/awards-&-recognition', category: 'Media', description: 'Awards and recognition received' },
  { name: 'Proposal Form', path: '/proposal-form', category: 'Forms & Downloads', description: 'Download proposal forms' },
  { name: 'Claim Form', path: '/claim-form', category: 'Forms & Downloads', description: 'Download claim forms' },
  { name: 'Complaint Resolution Form', path: '/complaint-resolution-form', category: 'Forms & Downloads', description: 'Complaint resolution forms' },
  { name: 'Un-Encashed Form', path: '/un-encahsed-form', category: 'Forms & Downloads', description: 'Un-encashed benefits form' },
  { name: 'Policies Form', path: '/policies-form', category: 'Forms & Downloads', description: 'Policy documents and forms' },
  { name: 'Proxy Forms', path: '/proxy-forms', category: 'Forms & Downloads', description: 'Proxy voting forms' },
  { name: 'Hospital Form', path: '/hospital-form', category: 'Forms & Downloads', description: 'Hospital network forms' },
  { name: 'Discount Form', path: '/discount-form', category: 'Forms & Downloads', description: 'Discount center forms' },
  { name: 'Marketing Collateral Forms', path: '/marketing-collateral-forms', category: 'Forms & Downloads', description: 'Marketing materials' },
  { name: 'Other Downloads', path: '/other-forms', category: 'Forms & Downloads', description: 'Additional documents and resources' },
  { name: 'Financial Reports', path: '/financial-reports', category: 'Financial Reports', description: 'Financial reports and statements' },
  { name: 'Financial Highlights', path: '/financial-highlights', category: 'Financial Reports', description: 'Financial highlights and summaries' },
  { name: 'NOGM', path: '/nogm', category: 'Financial Reports', description: 'Notice of General Meeting' },
  { name: 'Complain Box', path: '/compain-box', category: 'Support', description: 'Submit a complaint' },
  { name: 'Whistle Blowing', path: '/whistle-blowing', category: 'Support', description: 'Whistleblowing policy and form' },
  { name: 'FAQ', path: '/faq', category: 'Support', description: 'Frequently asked questions' },
  { name: 'Contact Us', path: '/contactus', category: 'Support', description: 'Contact information' },
  { name: 'Privacy Policy', path: '/privacy-policy', category: 'Support', description: 'Privacy policy and data protection' },
  { name: 'Sitemap', path: '/sitemap', category: 'Support', description: 'Website sitemap' },
];

// Enhanced search function with better matching
export const performComprehensiveSearch = (query) => {
  if (!query || query.trim().length < 2) {
    return [];
  }

  const lowerQuery = query.toLowerCase().trim();
  const queryWords = lowerQuery.split(/\s+/).filter(word => word.length > 0);
  const results = [];

  // Helper function to calculate relevance score (optionally pass title for title boost)
  const calculateScore = (text, query, queryWords, titleText = '') => {
    const lowerText = text.toLowerCase();
    const lowerTitle = (titleText && typeof titleText === 'string') ? titleText.toLowerCase() : '';
    let score = 0;

    // Exact phrase match (highest score)
    if (lowerText.includes(query) || (lowerTitle && lowerTitle.includes(query))) {
      score += 100;
    }

    // All words match (high score)
    const allWordsMatch = queryWords.every(word => lowerText.includes(word) || (lowerTitle && lowerTitle.includes(word)));
    if (allWordsMatch) {
      score += 50;
    }

    // Individual word matches + synonym expansion
    queryWords.forEach(word => {
      const inText = lowerText.includes(word);
      const inTitle = lowerTitle && lowerTitle.includes(word);
      if (inText) score += 10;
      if (inTitle) score += 25; // Title/name match gets higher score
      // Synonyms: if user typed "car", also match "motor", "vehicle"
      const synonyms = SEARCH_SYNONYMS[word];
      if (synonyms) {
        synonyms.forEach(syn => {
          if (lowerText.includes(syn) || (lowerTitle && lowerTitle.includes(syn))) score += 8;
        });
      }
    });

    return score;
  };

  // Search in routes/pages
  allRoutes.forEach((route) => {
    const searchableText = `${route.name} ${route.description || ''}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, route.name);
    
    if (score > 0) {
      results.push({
        type: 'page',
        title: route.name,
        path: route.path,
        category: route.category,
        description: route.description || `Navigate to ${route.name} page`,
        score,
        snippet: route.description || '',
      });
    }
  });

  // Search in News
  News.forEach((news) => {
    const searchableText = `${news.heading || ''} ${news.content || ''} ${news.excerpt || ''} ${news.content1 || ''} ${news.content2 || ''} ${news.content3 || ''} ${news.archead || ''}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, news.heading);
    
    if (score > 0) {
      results.push({
        type: 'news',
        title: news.heading || 'News Article',
        path: `/news-and-announcements/${news.Key}`,
        category: 'News & Announcements',
        description: news.excerpt || news.content?.substring(0, 200) || '',
        score,
        snippet: news.excerpt || news.content?.substring(0, 200) || '',
        key: news.Key,
        date: news.date || news.Date || '',
        image: news.feature || '',
      });
    }
  });

  // Search in Articles
  Articles.forEach((article) => {
    const searchableText = `${article.heading || ''} ${article.content || ''} ${article.excerpt || ''} ${article.content1 || ''} ${article.content2 || ''} ${article.content3 || ''} ${article.content4 || ''} ${article.content5 || ''} ${article.content6 || ''} ${article.content7 || ''} ${article.archead || ''}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, article.heading);
    
    if (score > 0) {
      results.push({
        type: 'article',
        title: article.heading || 'Article',
        path: `/articles-and-blogs/${article.Key}`,
        category: 'Articles & Blogs',
        description: article.excerpt || article.content?.substring(0, 200) || '',
        score,
        snippet: article.excerpt || article.content?.substring(0, 200) || '',
        key: article.Key,
        date: article.date || '',
        image: article.feature || '',
      });
    }
  });

  // Search in Product data (products use name + link)
  [...indvidualproducts, ...corporates, ...financials].forEach((product) => {
    const name = product.name || product.heading || product.title || '';
    const searchableText = `${name} ${product.link || ''}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, name);
    
    if (score > 0) {
      results.push({
        type: 'product',
        title: name || 'Product',
        path: product.link || '/Individual-Product',
        category: 'Products',
        description: `Salaam Takaful product: ${name}`,
        score,
        snippet: `Salaam Takaful product: ${name}`,
      });
    }
  });

  // Search in Directors
  SalaamDirectors.forEach((person) => {
    const searchableText = `${person.name || ''} ${person.designation || ''} ${stripHtml(person.detail || '')}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, person.name);
    if (score > 0) {
      results.push({
        type: 'page',
        title: `${person.name} - ${person.designation}`,
        path: '/governance',
        category: 'Company Information',
        description: person.designation || '',
        score,
        snippet: stripHtml(person.detail || '').substring(0, 200),
      });
    }
  });

  // Search in Management
  ManagementTeam.forEach((person) => {
    const searchableText = `${person.name || ''} ${person.designation || ''} ${stripHtml(person.detail || '')}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, person.name);
    if (score > 0) {
      results.push({
        type: 'page',
        title: `${person.name} - ${person.designation}`,
        path: '/management',
        category: 'Company Information',
        description: person.designation || '',
        score,
        snippet: stripHtml(person.detail || '').substring(0, 200),
      });
    }
  });

  // Search in Shariah advisors
  [...shariahData, ...advisorData].forEach((person) => {
    const searchableText = `${person.name || ''} ${person.designation || ''} ${stripHtml(person.detail || '')}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, person.name);
    if (score > 0) {
      results.push({
        type: 'page',
        title: `${person.name} - ${person.designation}`,
        path: '/shariah',
        category: 'Company Information',
        description: person.designation || '',
        score,
        snippet: stripHtml(person.detail || '').substring(0, 200),
      });
    }
  });

  // Search in Branches / Contact
  branches.forEach((branch) => {
    const searchableText = `${branch.city || ''} ${branch.address || ''} ${branch.contact?.email || ''} ${(branch.contact?.tel || []).join(' ')} ${branch.contact?.UAN || ''}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, branch.city);
    if (score > 0) {
      results.push({
        type: 'page',
        title: `${branch.city} - ${branch.address}`,
        path: '/contactus',
        category: 'Support',
        description: branch.address || '',
        score,
        snippet: branch.address || '',
      });
    }
  });

  // Search in Annual performance / videos
  annualperformance.forEach((section) => {
    (section.desc || []).forEach((item) => {
      const searchableText = (item.heading || '').toLowerCase();
      const score = calculateScore(searchableText, lowerQuery, queryWords, item.heading);
      if (score > 0) {
        results.push({
          type: 'page',
          title: item.heading || 'Annual Performance',
          path: '/annual-performance',
          category: 'Media',
          description: 'Annual performance review',
          score,
          snippet: item.heading || '',
        });
      }
    });
  });

  // Motor product search results intentionally disabled (restricted route)
  // (MotorsTabs || []).forEach((tab) => {
  //   const coverages = (tab.Coverages || []).map(c => c.li).join(' ');
  //   const optional = (tab.OptionalBenefits || []).map(o => o.li).join(' ');
  //   const searchableText = `${tab.mainheading || ''} ${tab.content || ''} ${tab.heading1 || ''} ${tab.heading2 || ''} ${coverages} ${optional}`.toLowerCase();
  //   const score = calculateScore(searchableText, lowerQuery, queryWords, tab.mainheading);
  //   if (score > 0) {
  //     results.push({
  //       type: 'product',
  //       title: tab.mainheading || 'Motor Takaful',
  //       path: '/individualproduct/salammotor',
  //       category: 'Products',
  //       description: tab.content?.substring(0, 200) || '',
  //       score,
  //       snippet: tab.content?.substring(0, 200) || tab.mainheading || '',
  //     });
  //   }
  // });

  // Search in FAQ (tableData, shariahQuestion, productQuestion)
  const faqEntries = [
    ...(faqTableData || []).map(item => ({ q: item.problem, a: item.answer, id: item.id })),
    ...(faqShariahQuestion || []).map(item => ({ q: item.question, a: item.answer || (item.list || []).map(l => l.point).join(' '), id: item.id })),
    ...(faqProductQuestion || []).map(item => ({ q: item.question, a: item.answer || (item.list || []).map(l => l.point).join(' '), id: item.id })),
  ];
  faqEntries.forEach((faq) => {
    const searchableText = `${faq.q || ''} ${faq.a || ''}`.toLowerCase();
    const score = calculateScore(searchableText, lowerQuery, queryWords, faq.q);
    if (score > 0) {
      results.push({
        type: 'page',
        title: faq.q?.substring(0, 80) + (faq.q?.length > 80 ? '...' : ''),
        path: '/faq',
        category: 'Support',
        description: 'FAQ - Frequently asked questions',
        score,
        snippet: (faq.a || faq.q || '').substring(0, 200),
      });
    }
  });

  // Deduplicate: keep highest-score result per path + title
  const seen = new Map();
  results.forEach((r) => {
    const key = `${r.path}|${r.title}`;
    if (!seen.has(key) || seen.get(key).score < r.score) seen.set(key, r);
  });
  const deduped = Array.from(seen.values());

  // Sort by relevance score (highest first)
  deduped.sort((a, b) => {
    if (b.score !== a.score) return b.score - a.score;
    const typePriority = { page: 4, news: 3, article: 2, product: 1 };
    return (typePriority[b.type] || 0) - (typePriority[a.type] || 0);
  });

  return deduped;
};

// Highlight search terms in text
export const highlightSearchTerms = (text, query) => {
  if (!text || !query) return text;
  
  const queryWords = query.trim().split(/\s+/).filter(word => word.length > 0);
  let highlightedText = text;
  
  queryWords.forEach(word => {
    const regex = new RegExp(`(${word})`, 'gi');
    highlightedText = highlightedText.replace(regex, '<mark>$1</mark>');
  });
  
  return highlightedText;
};

// Get snippet with highlighted terms
export const getSnippet = (text, query, maxLength = 200) => {
  if (!text) return '';
  
  const lowerText = text.toLowerCase();
  const queryWords = query.trim().split(/\s+/).filter(word => word.length > 0);
  
  // Find the first occurrence of any query word
  let startIndex = -1;
  for (const word of queryWords) {
    const index = lowerText.indexOf(word.toLowerCase());
    if (index !== -1) {
      startIndex = index;
      break;
    }
  }
  
  if (startIndex === -1) {
    // No match found, return beginning
    startIndex = 0;
  } else {
    // Start a bit before the match
    startIndex = Math.max(0, startIndex - 30);
  }
  
  let snippet = text.substring(startIndex, startIndex + maxLength);
  
  // Add ellipsis if needed
  if (startIndex > 0) {
    snippet = '...' + snippet;
  }
  if (startIndex + maxLength < text.length) {
    snippet = snippet + '...';
  }
  
  return snippet;
};
